// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ntjv{display:flex;flex-direction:column;gap:16px}.Xw5u{align-items:center;background-color:var(--grey-100);border-radius:8px;display:flex;gap:12px;justify-content:space-between;padding:16px 12px}.sYjG{align-items:center;color:var(--main-blue);cursor:pointer;display:inline-flex;font-family:\"Roboto\",sans-serif!important;font-size:14px;font-style:normal;font-weight:400;letter-spacing:.17px;line-height:20px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.HALI{--s:24px;height:24px;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarSettingsTriggers": "ntjv",
	"actionSidebarSettingsTriggersField": "Xw5u",
	"actionSidebarSettingsQueryText": "sYjG",
	"actionSidebarSettingsQueryIcon": "HALI"
};
module.exports = ___CSS_LOADER_EXPORT___;
